import { useState } from "react"
import { HomeHeaderNavs } from "../../Interfaces/componentTypes"
import BusinessDashboard from "../BusinessDashboard/businessDashboard";

const useHomePageHooks = ()=>{
    const getTabFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get('tab') as HomeHeaderNavs;
    };
    const initialTab = getTabFromUrl() || HomeHeaderNavs.Business;    
    const [pageContent,setPageContent] = useState<HomeHeaderNavs>(initialTab);
    const PAGE_CONTENTS = {
        [HomeHeaderNavs.Home]:<p>Home</p>,
        [HomeHeaderNavs.Business]:<BusinessDashboard/>,
      }
    const onSetPageContent = (title:HomeHeaderNavs)=>{
        setPageContent(title);
        const currentUrl = window.location.href.split('?')[0];
        window.history.pushState({}, '', `${currentUrl}?tab=${title}`);
    };

    return {
        pageContent,
        onSetPageContent,
        PAGE_CONTENTS
    }
};

export default useHomePageHooks